import type { SchoolLevel, SubjectSlug, ExerciseDifficulty } from '@jeraisonne/db';

export type PlayerSearchableExercise = {
  id: string;
  title: string;
  difficulty: ExerciseDifficulty;
  chapters: {
    title: string;
    subject: SubjectSlug;
    level: SchoolLevel;
  } | null;
};

export type PlayerSearchFilters = {
  search: string;
  subject: SubjectSlug | '';
  level: SchoolLevel | '';
  difficulty: ExerciseDifficulty | '';
};

/**
 * Filtre côté client appliqué après la requête Supabase.
 * - `subject` / `level` / `difficulty` filtrent strictement (égalité).
 * - `search` est un match insensible à la casse sur le titre de l'exercice
 *   OU le titre du chapitre.
 * - Un exercice sans `chapters` (relation manquante) est exclu.
 */
export function filterExercisesForPlayer<T extends PlayerSearchableExercise>(
  exercises: ReadonlyArray<T>,
  filters: PlayerSearchFilters,
): T[] {
  const term = filters.search.trim().toLowerCase();
  return exercises.filter((ex) => {
    if (!ex.chapters) return false;
    if (filters.subject && ex.chapters.subject !== filters.subject) return false;
    if (filters.level && ex.chapters.level !== filters.level) return false;
    if (filters.difficulty && ex.difficulty !== filters.difficulty) return false;
    if (term) {
      const hay = `${ex.title} ${ex.chapters.title}`.toLowerCase();
      if (!hay.includes(term)) return false;
    }
    return true;
  });
}
